import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLR410030_01,
    explanatoryTextRule: "\\n",
  },
  {
    title: "退職者名",
    keyword: "staffName",
    type: "contractorAndNumber",
    contractorName: "退職者名",
    showLine: false,
  },
  {
    title: "請求書の提出完了日",
    keyword: "retirementInvoiceReceptionDay",
    type: "text",
  },
  {
    title: "退職手当金の請求に係る処理状況",
    keyword: "paymentStatus",
    type: "text",
  },
  {
    title: "退職手当金の支給予定額（税引前）",
    keyword: "paymentAmt",
    type: "text",
  },
  {
    title: "退職手当金の振込（予定）日",
    keyword: "payDay",
    type: "text",
  },
  {
    title: "被共済職員期間",
    keyword: "maePeriod",
    type: "text",
  },
  {
    lineTitle: "取下げ理由",
    keyword: "lineTitle",
    type: "lineTitle",
  },
  {
    title: "取下げ理由",
    keyword: "cancelReason",
    inputProps: { maxLength: 500 },
    requiredIcon: true,
  },
];

const schema = {
  cancelReason: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 500,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "500"),
    },
  },
};

export { fakeTableList, schema };
